var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeedActive = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
  id: "Vector",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(3.000000, 2.000000)",
  fill: "#6467EF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.5527516,-2.19929894e-14 L5.39110465,0.00488092523 C3.893854,0.0955735965 2.72727273,1.43841048 2.72727273,3.05041322 L2.72727273,6.81454545 L1.54545455,6.81525537 C0.691923568,6.81525537 -6.76707367e-15,7.50717894 -6.76707367e-15,8.36070992 L-6.76707367e-15,16.4111231 C-6.76707367e-15,17.9152928 0.925726953,19.2160146 2.21644668,19.4198612 L2.3237273,19.4369559 C2.3989185,19.4463656 2.48074121,19.451619 2.56493506,19.451619 L3.31454545,19.4509091 L3.36363636,19.4545455 L14.8108848,19.4545455 C16.3855754,19.4545455 17.6363636,18.0818786 17.6363636,16.4140496 L17.6363636,1.54545455 C17.6363636,0.691923568 16.9444401,-2.19929894e-14 16.0909091,-2.19929894e-14 L5.5527516,-2.19929894e-14 Z M3.36363636,8.08798265 C3.59793898,8.08798265 3.61430262,11.4525945 3.41272727,18.1818182 L3.36363636,18.1788917 L2.56493506,18.1788917 C2.52053446,18.1788917 2.48036576,18.1749663 2.43642479,18.1664775 C1.7949328,18.0647883 1.27272727,17.331047 1.27272727,16.4111231 L1.27272727,8.36070992 C1.27272727,8.2100868 1.39483143,8.08798265 1.54545455,8.08798265 L3.36363636,8.08798265 Z M14.5053375,14.1681922 L14.5053375,15.4409195 L5.71428571,15.4409195 L5.71428571,14.1681922 L14.5053375,14.1681922 Z M14.5053375,10.868341 L14.5053375,12.1410682 L5.71428571,12.1410682 L5.71428571,10.868341 L14.5053375,10.868341 Z M14.5053375,7.56064073 L14.5053375,8.833368 L5.71428571,8.833368 L5.71428571,7.56064073 L14.5053375,7.56064073 Z M14.5053375,4.26078947 L14.5053375,5.53351675 L5.71428571,5.53351675 L5.71428571,4.26078947 L14.5053375,4.26078947 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "4.01904762 7 4.01904762 18.8181818 2.76190476 18.8181818 2.76190476 7"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeedActive);
export default ForwardRef;